import * as React from 'react';
import {useContext} from "react";
import {StoreContext} from "../../../stores/StoreLoader";
import MegaNav from "../navigation/meganav/MegaNav";
import {buildCssUrlString} from "../../../utils/StringUtilities";
import {observer} from "mobx-react";
import classNames from 'classnames';
import ClickableLink from "../../utilities/ClickableLink";
import styles from "../styles/Header.module.scss"

const MinimalTheme: React.FC<{
    toggleUserMenu: () => void,
    openLoginModal: () => void,
    mainUrl: string,
}> = observer(props => {
    const {organizationStore, userStore, interfaceStore} = useContext(StoreContext);

    const smallWidth = interfaceStore.width < 1216;

    const navbarContainerClassName = classNames({
        "sb-navbar-primary-container": true,
        "clearfix": true,
        "sb-content-width-plus-margin": true,
        [styles.container]: true,
    })

    const logoContainerClassName = classNames({
        "sb-navbar-primary-element": true,
        "sb-navbar-primary-element-logo": true,
        "sb-navbar-logo": true,
        "notranslate": true,
    })

    const hideLoginButton = organizationStore.organization.json_data.settings.appearance.hideLoginButton;

    return <nav id={"primaryNav"}
                className="sb-primary-nav sb-navbar-background sb-organization-color-primary-nav"
                role="navigation" dir="ltr">
        <div className={navbarContainerClassName}>
            <div className="sb-navbar-table">
                <div className="sb-navbar-row">
                    <div className="sb-navbar-cell">
                        {organizationStore.organization.logo && <span className={logoContainerClassName}>
                            <ClickableLink href={props.mainUrl}
                                           className="sb-organization-font-color sb-home-link"
                                           title={organizationStore.organization.title}>
                                <img className="sb-navbar-logo" src={organizationStore.organization.logo}
                                     alt={organizationStore.organization.title}/>
                                <span className="sr-only">{organizationStore.organization.title}</span>
                            </ClickableLink>
                        </span>}
                        {/*large width*/}
                        <span className="sb-organization-color-secondary-nav">
                            <div className="cd-main-header" style={{float: "left"}}>
                                <MegaNav/>
                            </div>
                        </span>
                        <span className="sb-minimal-theme-login-button-container">
                            {!hideLoginButton && (userStore.id ? <button id="userMenuButton"
                                                                         className="btn sb-organization-color-element-bg"
                                                                         style={{whiteSpace: "nowrap"}} aria-label="Open menu drawer"
                                                                         onClick={props.toggleUserMenu}>
                                <div className="sb-navbar-button-image"
                                     style={{backgroundImage: buildCssUrlString(userStore.avatar)}}/>
                                <div className="sb-navbar-button-text" aria-hidden="true">Account</div>
                            </button> :
                            <button id="loginMenuButton" className="btn sb-organization-color-element-bg"
                                    onClick={props.openLoginModal}>
                                <span className="sb-navbar-button-text">Login</span>
                            </button>)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </nav>
})

export default MinimalTheme;
